import { toast } from "sonner";
import { api } from "./api";

export const PRODUCTS = {
  "physique-transformation": { label: "12-Week Body Transformation", price: 9999 },
  "nutrition-blueprint": { label: "Custom Nutrition & Dietetics Blueprint", price: 6999 },
  "executive-protocol": { label: "Executive Lifestyle Protocol", price: 8999 },
  consultation: { label: "1-on-1 Consultation Booking", price: 499 },
};

const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";
export const COACH_WHATSAPP = "917709589870";

export function whatsappEnrollUrl(product) {
  const p = PRODUCTS[product];
  const text = p
    ? `Hi Nikhil, I want to enroll in the ${p.label} (₹${p.price.toLocaleString("en-IN")}). Please send me the payment link.`
    : "Hi Nikhil, I want to enroll in your coaching. Please send me the payment link.";
  return `https://wa.me/${COACH_WHATSAPP}?text=${encodeURIComponent(text)}`;
}

export function goToWhatsapp(product) {
  window.open(whatsappEnrollUrl(product), "_blank", "noopener,noreferrer");
}

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${RAZORPAY_SRC}"]`);
    const script = existing || document.createElement("script");
    const done = (ok) => resolve(ok && Boolean(window.Razorpay));
    script.addEventListener("load", () => done(true), { once: true });
    script.addEventListener("error", () => done(false), { once: true });
    if (!existing) {
      script.src = RAZORPAY_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    setTimeout(() => done(true), 8000);
  });
}

/**
 * Opens the Razorpay checkout modal.
 * Returns { opened: true } on success, or { fallback: "<reason>" } when checkout
 * cannot be started — the caller then sends the client to WhatsApp instead.
 */
export async function openCheckout({ product, prefill = {}, onSuccess }) {
  const scriptReady = await loadRazorpayScript();
  if (!scriptReady) return { fallback: "script" };

  let cfg;
  let order;
  try {
    cfg = await api("/payments/config");
    order = await api("/payments/create-order", {
      method: "POST",
      body: JSON.stringify({ product }),
    });
  } catch (err) {
    return { fallback: "order", message: err.message };
  }
  if (!cfg?.key_id || !order?.order_id) return { fallback: "order" };

  try {
    const rzp = new window.Razorpay({
      key: cfg.key_id,
      amount: order.amount,
      currency: "INR",
      name: "Fitness Fanatic Nik",
      description: PRODUCTS[product].label,
      order_id: order.order_id,
      prefill,
      theme: { color: "#10B981", backdrop_color: "#0B0F19" },
      handler: async (res) => {
        try {
          await api("/payments/verify", {
            method: "POST",
            body: JSON.stringify({
              razorpay_order_id: res.razorpay_order_id,
              razorpay_payment_id: res.razorpay_payment_id,
              razorpay_signature: res.razorpay_signature,
            }),
          });
          onSuccess?.(res);
        } catch (err) {
          toast.error(err.message || "Payment verification failed. Contact support if amount was deducted.");
        }
      },
    });
    rzp.on("payment.failed", () => {
      toast.error("Payment failed. No amount was deducted — please try again.");
    });
    rzp.open();
    return { opened: true };
  } catch (err) {
    return { fallback: "modal", message: err?.message };
  }
}
